import formatDateLocale from '../../../../helper/formatDateLocale'

export default (props) => {
  const { value, formatStr = 'P', currentLanguage } = props
  return value ? formatDateLocale(currentLanguage, value, formatStr) : ''
}
